/* ================================================================
   NOSMELL PRO THEME v2.0 — theme.js
   Cart Drawer · Quick View · Animations · Header · Mobile Nav
   ================================================================ */
(function(){
'use strict';

/* ── HEADER SCROLL ── */
var header = document.getElementById('site-header');
if(header){
  window.addEventListener('scroll',function(){ header.classList.toggle('scrolled', window.scrollY>60); },{passive:true});
}

/* ── MOBILE NAV DRAWER ── */
var hbBtn      = document.getElementById('hamburger');
var mobileNav  = document.getElementById('mobile-nav');
var mobileOverlay = document.getElementById('mobile-nav-overlay');
var mobileClose   = document.getElementById('mobile-nav-close');

function openMobileNav() {
  if (!mobileNav) return;
  mobileNav.classList.add('open');
  mobileNav.setAttribute('aria-hidden', 'false');
  if (mobileOverlay) { mobileOverlay.classList.add('open'); mobileOverlay.setAttribute('aria-hidden', 'false'); }
  if (hbBtn) hbBtn.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
  if (mobileClose) mobileClose.focus();
}

function closeMobileNav() {
  if (!mobileNav) return;
  mobileNav.classList.remove('open');
  mobileNav.setAttribute('aria-hidden', 'true');
  if (mobileOverlay) { mobileOverlay.classList.remove('open'); mobileOverlay.setAttribute('aria-hidden', 'true'); }
  if (hbBtn) hbBtn.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
  if (hbBtn) hbBtn.focus();
}

if (hbBtn)         hbBtn.addEventListener('click', openMobileNav);
if (mobileClose)   mobileClose.addEventListener('click', closeMobileNav);
if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeMobileNav();
    if(typeof window.closeCart === 'function') window.closeCart();
  }
});

/* ── CART STATE ── */
window.updateCartUI = function(cart){
  var bubble = document.getElementById('cart-bubble');
  var count  = document.getElementById('drawer-count');
  var sub    = document.getElementById('drawer-subtotal');
  if(bubble){ bubble.textContent=cart.item_count; bubble.style.display=cart.item_count>0?'flex':'none'; }
  if(count)  count.textContent='('+cart.item_count+')';
  if(sub)    sub.textContent=formatMoney(cart.total_price);
  updateFreeShip(cart.total_price);
  refreshCartItems(cart);
};

function updateFreeShip(total){
  var el = document.getElementById('drawer-free-ship');
  if(!el) return;
  var threshold=5000, remaining=threshold-total;
  if(total>=threshold){
    el.innerHTML='<span class="free-ship__done">🎉 You\'ve unlocked free UK shipping!</span>';
  } else {
    var pct=Math.min(100,Math.round(total*100/threshold));
    el.innerHTML='<span>Spend <strong>'+formatMoney(remaining)+'</strong> more for free UK shipping</span><div class="free-ship__bar"><div class="free-ship__fill" style="width:'+pct+'%"></div></div>';
  }
}

function refreshCartItems(cart){
  var container=document.getElementById('cart-items');
  if(!container) return;
  if(cart.item_count===0){
    container.innerHTML='<div class="cart-empty"><div class="cart-empty__icon">🛍️</div><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary btn--sm">Start Shopping</a></div>';
    return;
  }
  var html='';
  cart.items.forEach(function(item){
    /* ── FIX: use featured_image.url if image is a full CDN URL ── */
    var imgSrc = '';
    if(item.featured_image && item.featured_image.url){
      imgSrc = item.featured_image.url;
    } else if(item.image){
      imgSrc = item.image;
    }
    /* append width param for Shopify CDN */
    if(imgSrc && imgSrc.indexOf('?') === -1){
      imgSrc = imgSrc + '?width=160';
    } else if(imgSrc){
      imgSrc = imgSrc + '&width=160';
    }
    var img = imgSrc ? '<img src="'+imgSrc+'" alt="'+escHtml(item.title)+'" width="72" height="72" loading="lazy"/>' : '';
    var variant = item.variant_title && item.variant_title!=='Default Title' ? '<p class="cart-item__variant">'+escHtml(item.variant_title)+'</p>' : '';
    html+='<div class="cart-item" data-key="'+item.key+'">'+
      '<a href="'+item.url+'" class="cart-item__img-wrap">'+img+'</a>'+
      '<div class="cart-item__details">'+
        '<a href="'+item.url+'" class="cart-item__name">'+escHtml(item.product_title)+'</a>'+
        variant+
        '<div class="cart-item__row">'+
          '<div class="cart-qty">'+
            '<button class="cart-qty__btn" data-action="minus" data-key="'+item.key+'" aria-label="Decrease">−</button>'+
            '<span class="cart-qty__val">'+item.quantity+'</span>'+
            '<button class="cart-qty__btn" data-action="plus" data-key="'+item.key+'" aria-label="Increase">+</button>'+
          '</div>'+
          '<span class="cart-item__price">'+formatMoney(item.final_line_price)+'</span>'+
        '</div>'+
      '</div>'+
      '<button class="cart-item__remove" data-key="'+item.key+'" aria-label="Remove">'+
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'+
      '</button>'+
    '</div>';
  });
  container.innerHTML=html;
  bindCartItemEvents();
}

function bindCartItemEvents(){
  document.querySelectorAll('.cart-qty__btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var key=this.dataset.key, action=this.dataset.action;
      var valEl=this.parentElement.querySelector('.cart-qty__val');
      var qty=parseInt(valEl?valEl.textContent:1);
      var newQty=action==='minus'?Math.max(0,qty-1):qty+1;
      cartChange(key,newQty);
    });
  });
  document.querySelectorAll('.cart-item__remove').forEach(function(btn){
    btn.addEventListener('click',function(){ cartChange(this.dataset.key,0); });
  });
}
bindCartItemEvents();

function cartChange(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
  .then(function(r){return r.json();})
  .then(function(cart){ window.updateCartUI(cart); })
  .catch(function(e){ console.error('Cart change error',e); });
}

/* ── CART DRAWER OPEN/CLOSE ── */
var cartOverlay = document.getElementById('cart-overlay');
var cartDrawer  = document.getElementById('cart-drawer');
var cartClose   = document.getElementById('cart-close');
var cartToggle  = document.getElementById('cart-toggle');

window.openCart = function(){
  if(!cartDrawer) return;
  cartDrawer.classList.add('open');
  cartDrawer.setAttribute('aria-hidden','false');
  if(cartOverlay){ cartOverlay.classList.add('open'); cartOverlay.setAttribute('aria-hidden','false'); }
  document.body.style.overflow='hidden';
  cartClose && cartClose.focus();
};
window.closeCart = function(){
  if(!cartDrawer) return;
  cartDrawer.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden','true');
  if(cartOverlay){ cartOverlay.classList.remove('open'); cartOverlay.setAttribute('aria-hidden','true'); }
  document.body.style.overflow='';
  cartToggle && cartToggle.focus();
};
if(cartToggle) cartToggle.addEventListener('click', window.openCart);
if(cartClose)  cartClose.addEventListener('click',  window.closeCart);
if(cartOverlay) cartOverlay.addEventListener('click', window.closeCart);

/* ── QUICK ADD (product cards) ── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.product-card__atc');
  if(!btn||btn.disabled) return;
  e.preventDefault();
  var vid=parseInt(btn.dataset.variantId);
  if(!vid) return;
  var orig=btn.textContent;
  btn.innerHTML='<span class="spinner"></span>';
  btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
  .then(function(r){return r.json();})
  .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
  .then(function(r){return r.json();})
  .then(function(cart){
    window.updateCartUI(cart);
    window.openCart();
    showToast('Added to cart!');
    btn.textContent='✓ Added'; btn.style.background='var(--c-sage)';
    setTimeout(function(){ btn.textContent=orig; btn.style.background=''; btn.disabled=false; },2000);
  }).catch(function(){ btn.textContent=orig; btn.disabled=false; });
});

/* ── QUICK VIEW ── */
var qvModal = document.getElementById('quick-view-modal');
var qvBody  = document.getElementById('qv-body');
var qvClose = document.getElementById('qv-close');
var qvOverlay = document.getElementById('qv-overlay');

function openQV(url){
  if(!qvModal) return;
  qvModal.hidden=false;
  document.body.style.overflow='hidden';
  qvBody.innerHTML='<div class="qv-loading"><span class="spinner-lg"></span></div>';

  fetch(url,{headers:{'Accept':'text/html'}})
  .then(function(r){return r.text();})
  .then(function(html){
    var parser=new DOMParser();
    var doc=parser.parseFromString(html,'text/html');
    var info=doc.querySelector('.product-info');
    var gallery=doc.querySelector('.product-gallery');

    if(info){
      /* ── Gallery HTML ── */
      var gHtml='<div class="qv-gallery">';
      if(gallery){
        var mainImg=gallery.querySelector('#main-img');
        gHtml+='<div class="qv-gallery__main">'+(mainImg?mainImg.outerHTML:'')+'</div>';
        var thumbs=gallery.querySelectorAll('.gallery-thumb');
        if(thumbs.length>1){
          gHtml+='<div class="qv-gallery__thumbs">';
          thumbs.forEach(function(t){ gHtml+=t.outerHTML; });
          gHtml+='</div>';
        }
      }
      gHtml+='</div>';

      /* ── Info HTML ── */
      var infoHtml=info.outerHTML.replace('class="product-info"','class="qv-info"');

      /* ── Variants JSON ── */
      var variantsScript=doc.getElementById('product-variants-json');
      var variantsJson = variantsScript ? variantsScript.textContent : '[]';

      qvBody.innerHTML=gHtml+infoHtml;

      /* ── Inject variants into QV ── */
      var qvVariantsEl = qvBody.querySelector('#product-variants-json');
      if(!qvVariantsEl){
        var s=document.createElement('script');
        s.type='application/json';
        s.id='product-variants-json';
        s.textContent=variantsJson;
        qvBody.appendChild(s);
      }

      /* ── Gallery thumbs ── */
      qvBody.querySelectorAll('.gallery-thumb').forEach(function(t){
        t.addEventListener('click',function(){
          qvBody.querySelectorAll('.gallery-thumb').forEach(function(x){ x.classList.remove('active'); });
          this.classList.add('active');
          var mainI=qvBody.querySelector('.qv-gallery__main img');
          if(mainI) mainI.src=this.dataset.src;
        });
      });

      /* ── QV Variants ── */
      var qvVariants = [];
      try { qvVariants = JSON.parse(variantsJson); } catch(e){}

      var qvSelectedOpts = [];

      /* ── Option swatches ── */
      qvBody.querySelectorAll('.opt-swatch').forEach(function(btn){
        btn.addEventListener('click',function(){
          var idx=parseInt(this.dataset.optionIndex);
          var val=this.dataset.value;
          qvSelectedOpts[idx]=val;
          this.closest('.option-swatches').querySelectorAll('.opt-swatch').forEach(function(b){
            b.classList.remove('active');
            b.setAttribute('aria-pressed','false');
          });
          this.classList.add('active');
          this.setAttribute('aria-pressed','true');
          var selEl=qvBody.querySelector('#opt-selected-'+idx);
          if(selEl) selEl.textContent=val;
          updateQVVariant();
        });
      });

      function updateQVVariant(){
        var opts=[];
        qvBody.querySelectorAll('.option-group').forEach(function(g,i){
          var active=g.querySelector('.opt-swatch.active');
          if(active) opts[i]=active.dataset.value;
        });
        var v=qvVariants.find(function(vr){ return vr.options.every(function(o,i){ return o===opts[i]; }); });
        if(!v) v=qvVariants.find(function(vr){ return vr.options.every(function(o,i){ return opts[i]==null||o===opts[i]; }); });
        if(!v) return;
        var vidEl=qvBody.querySelector('#selected-variant-id');
        if(vidEl) vidEl.value=v.id;
        var priceEl=qvBody.querySelector('#price-display');
        if(priceEl) priceEl.textContent='£'+(v.price/100).toFixed(2);
        var cpEl=qvBody.querySelector('#compare-price');
        if(cpEl){ if(v.compare_at_price>v.price){ cpEl.textContent='£'+(v.compare_at_price/100).toFixed(2); cpEl.style.display=''; }else{ cpEl.style.display='none'; } }
        var atcBtn=qvBody.querySelector('#atc-btn');
        if(atcBtn){ atcBtn.disabled=!v.available; atcBtn.textContent=v.available?'Add to Cart':'Sold Out'; }
      }

      /* ── QV Qty ── */
      var qvQtyInput=qvBody.querySelector('#qty-input');
      var qvMinus=qvBody.querySelector('#qty-minus');
      var qvPlus=qvBody.querySelector('#qty-plus');
      if(qvMinus) qvMinus.addEventListener('click',function(){ if(qvQtyInput&&parseInt(qvQtyInput.value)>1) qvQtyInput.value=parseInt(qvQtyInput.value)-1; });
      if(qvPlus)  qvPlus.addEventListener('click',function(){ if(qvQtyInput) qvQtyInput.value=parseInt(qvQtyInput.value)+1; });

      /* ── QV Add to Cart ── */
      var atcBtn=qvBody.querySelector('#atc-btn');
      if(atcBtn){
        atcBtn.addEventListener('click',function(){
          var vidEl=qvBody.querySelector('#selected-variant-id');
          var vid=vidEl?vidEl.value:null;
          if(!vid) return;
          var qty=qvQtyInput?parseInt(qvQtyInput.value)||1:1;
          var orig=this.textContent;
          this.innerHTML='<span class="spinner"></span>';
          this.disabled=true;
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(vid),quantity:qty}]})})
          .then(function(r){return r.json();})
          .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
          .then(function(r){return r.json();})
          .then(function(cart){
            window.updateCartUI(cart);
            closeQV();
            window.openCart();
            showToast('Added to cart!');
          }).catch(function(){ atcBtn.textContent=orig; atcBtn.disabled=false; });
        });
      }

    } else {
      qvBody.innerHTML='<div class="qv-info" style="padding:40px;text-align:center"><p>Unable to load product. <a href="'+url+'">View full page →</a></p></div>';
    }
  }).catch(function(){
    qvBody.innerHTML='<div class="qv-info" style="padding:40px;text-align:center"><p>Unable to load product. <a href="'+url+'">View full page →</a></p></div>';
  });
}

function closeQV(){
  if(!qvModal) return;
  qvModal.hidden=true;
  document.body.style.overflow='';
}

document.addEventListener('click',function(e){
  var btn=e.target.closest('.product-card__qv');
  if(btn){ e.preventDefault(); openQV(btn.dataset.url); }
});
if(qvClose) qvClose.addEventListener('click',closeQV);
if(qvOverlay) qvOverlay.addEventListener('click',closeQV);

/* ── WISHLIST (local storage) ── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.product-card__wishlist');
  if(!btn) return;
  btn.classList.toggle('active');
  var pid=btn.closest('.product-card')?.dataset.productId;
  if(pid){
    try{
      var saved=JSON.parse(localStorage.getItem('ns-wishlist')||'[]');
      var idx=saved.indexOf(pid);
      if(idx>-1) saved.splice(idx,1); else saved.push(pid);
      localStorage.setItem('ns-wishlist',JSON.stringify(saved));
      showToast(idx>-1?'Removed from wishlist':'Saved to wishlist');
    }catch(e){}
  }
});

/* ── CART PAGE QTY ── */
document.querySelectorAll('.qty-ctrl__btn[data-action]').forEach(function(btn){
  btn.addEventListener('click',function(){
    var key=this.dataset.key, action=this.dataset.action;
    var row=this.closest('.cart-row');
    var input=row?.querySelector('.qty-ctrl__val');
    if(input){
      var qty=parseInt(input.value);
      var newQty=action==='minus'?Math.max(0,qty-1):qty+1;
      input.value=newQty;
    }
  });
});
document.querySelectorAll('.cart-row__remove').forEach(function(btn){
  btn.addEventListener('click',function(){
    var key=this.dataset.key;
    var row=this.closest('.cart-row');
    if(row) row.style.opacity='.4';
    cartChange(key,0);
    if(row) setTimeout(function(){ row.remove(); },400);
  });
});

/* ── TOAST ── */
var toastEl=document.getElementById('toast');
var toastMsg=document.getElementById('toast-msg');
var toastTimer;
function showToast(msg){
  if(!toastEl||!toastMsg) return;
  toastMsg.textContent=msg;
  toastEl.hidden=false;
  clearTimeout(toastTimer);
  toastTimer=setTimeout(function(){ toastEl.hidden=true; },2800);
}

/* ── SCROLL REVEAL ── */
if('IntersectionObserver' in window){
  var revObs=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('visible');
        revObs.unobserve(entry.target);
      }
    });
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ revObs.observe(el); });
}

/* ── SMOOTH ANCHORS ── */
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var target=document.querySelector(this.getAttribute('href'));
    if(target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth',block:'start'}); }
  });
});

/* ── HELPERS ── */
function formatMoney(cents){
  return '£'+(cents/100).toFixed(2).replace(/\.00$/,'');
}
function escHtml(str){
  return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ── REVIEW BARS ANIMATION ── */
setTimeout(function(){
  document.querySelectorAll('.review-bar__fill').forEach(function(el){
    var w=el.style.width; el.style.width='0'; setTimeout(function(){ el.style.width=w; },100);
  });
},500);

})();